<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="850">
            <v-card>
                <v-card-title>{{ $t("TRUCK_DISPLAY_TITLE")}}</v-card-title>
                <v-card-subtitle>{{ $t("TRUCK_DISPLAY_SUBTITLE") }}</v-card-subtitle>
                <v-card-text>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate
                        color="primary">
                    </v-progress-circular>
                </div>
                <v-row v-else>
                    <v-col v-if="truck">
                        <v-simple-table dense>
                            <tbody>
                                <tr>
                                    <th>{{ $t("TRUCK_PLATE") }}</th>
                                    <td>{{ truck.plate_number }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t("TRUCK_TYPE") }}</th>
                                    <td>{{ truck.truck_type }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t("TRUCK_BRAND") }}</th>
                                    <td>{{ truck.truck_brand }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t("MODEL_NAME") }}</th>
                                    <td>{{ truck.truck_model }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t("TRUCK_YEAR_MAKE") }}</th>
                                    <td>{{ truck.year_make }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <v-col v-if="truck">
                        <v-simple-table dense>
                            <tbody>
                                <tr>
                                    <th>{{ $t("TRUCK_CHASIS") }}</th>
                                    <td>{{ truck.chasis_number }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t("TRUCK_ENGN_NUM") }}</th>
                                    <td>{{ truck.engine_number }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t("TRUCK_NOTES") }}</th>
                                    <td>{{ truck.notes }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        @click="close">
                        {{ $t("BTN_CLOSE") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="submitRetryDialog"/>
    </div>
</template>

<script>
import RetryDialog from '../components/RetryDialog';
import { mapState, mapActions } from 'vuex';
export default {
    name: "TruckDisplayDialog",
    components: {
        RetryDialog
    },
    data() {
        return {
            display: false,
            id: null,
            loading: {
                data: false
            },
            mode: {
                edit: false
            },
            error: {
                openFetch: {
                    state: false,
                    message: null
                }
            }
        }
    },
    computed: {
        ...mapState("truck", ["truck"])
    },
    methods: {
        ...mapActions("truck", ["fetchTruck"]),
        async open(params) {
            this.id = params.id;
            this.loading.data = true;
            this.display = true;
            this.initDataFetch();
        },
        async initDataFetch() {
            try {
                await this.fetchTruck(this.id);
                this.loading.data = false;
            } catch(error) {
                let message = null;
                if(error.response) message = error.response.data.message;
                else message = error;
                this.$refs.retryDialog.open({target: "initDataFetch", message, closeBtn: true});
            }
        },
        submitRetryDialog(params) {
            if(params.target == "initDataFetch") {
                if(params.retry == true) this.initDataFetch();
                else this.close();
            }
        },
        close() {
            this.display = false;
        }
    }
}
</script>